import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    
    code:0
    
}
const mutations={
    agent_user_search(state,value){

        if(value.type=="post"){
         
            post(urls.admin.agent_user.getagentuser,value).then((result)=>{
               
                state.result=result



            })

        }

    },
   

   
    
    
   
 
    

}
const  actions={
   
    AgentUserSearchAction(context,value){
       
        context.commit("agent_user_search",value)
       
    },
    
  
    
  
    
  
    
   

}

export default {state,mutations,actions}